import { takeLatest, call } from 'redux-saga/effects';

import { CHANGE_SORTING } from '../constants/sorting';

import { fetchData } from './search';

import { currentUri as URI, updateURL } from '../../../utils/uriUtils';

const SORTING_PARAM = 'sort_by';

function* changeURL(action) {
  try {
    const { field, order } = action.payload;

    URI.removeSearch(SORTING_PARAM);
    URI.addSearch(SORTING_PARAM, order ? `${field},${order}` : field);
    updateURL();

    yield call(fetchData);
  } catch (error) {
    console.error('Произошла ошибка', error);
  }
}

export default function* () {
  yield takeLatest(CHANGE_SORTING, changeURL);
}
